<script>

///Ultima alteração: 27/05/2020
///Alterado por: Allinne

	import CaracteristicaItem       from './BarraCaracteristicas__Item.svelte';

	export let realty       = null;
	export let style        = "";
	export let hideItems    = [];
	const caracteristicas    = [
		"Id",
		"Bathrooms",
		"Bedrooms",
		"ParkingSpots",
		"Furnished",
		"SemiFurnished",
		"Area",
		"LotArea"
	];
</script>

<div class="caracteristicas">
	<slot>
		{#each caracteristicas as caracteristica}
			{#if hideItems.indexOf(caracteristica) == -1}
				<CaracteristicaItem style={style} realty={realty} type={caracteristica}/>
			{/if}
		{/each}
	</slot>
</div> 

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

.caracteristicas
	display: flex
	align-items: center
	justify-content: center
	flex-wrap: wrap
	text-align: center
	font-size: inherit
</style>